var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center",staticStyle:{"height":"100%"}},[(_vm.formattedSeoValue == 'loading')?_c('div',{staticClass:"sloader"}):_c('vs-chip',{staticStyle:{"font-size":"12px"},attrs:{"color":_vm.getGradColor(101 - _vm.formattedSeoValue)}},[_vm._v("\n\t\t  "+_vm._s(_vm.formattedSeoValue)+"  \n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }